VjsAdmin.googleMappingSettings = (function () {
    const districtGuid = $('.district-info').data('district-guid');
    const platformId = $('.platform-info').data('platform-id');
    const init = function () {
        new GoogleMappingClickEvent();
        initOrgUnitTable();
        Handlebars.registerHelper('notZero', (value) => value !== '0');
    };
    const successAlert = function (alertMessage) {
        const alert = `<div class="alert alert-success" role="alert">\
                            <i class="fa fa-thumbs-o-up" aria-hidden="true"></i>\
                            <span>${alertMessage}</span>\
                            <a href="#" class="close" data-dismiss="alert" aria-label="close">×</a>\
                        </div>`;

        $('.alert-div').html(alert);
    };
    const dangerAlert = function (alertMessage) {
        const alert = `<div class="alert alert-danger" role="alert">\
                            <span>${alertMessage}</span>\
                        </div>`;
        $('.alert-div').html(alert);
    };

    const GoogleMappingClickEvent = VjsUtility.Controller.extend({
        events: {
            'click #refresh-orgunit': 'clickRefreshOrgUnit',
            'click .save-settings': 'clickSaveMappingSettings',
        },
        clickRefreshOrgUnit: () => {
            $('.district-info').data();
            const selections = $('#mapping-settings-org-units-table').bootstrapTable('getSelections');
            const selectionIds = selections.map((org) => org.orgUnitId);
            const req = new VjsUtility.Request();
            req.put(
                Slim.Router.pathFor('platforms.districts.google.mapping_settings.refresh', {
                    platform_id: platformId,
                    district_joint_guid: districtGuid,
                }),
                { orgUnits: selectionIds },
            )
                .done(() => {
                    VjsUtility.Notification.success({
                        text: 'Org units refreshed',
                        time: 5000,
                    });
                    initOrgUnitTable();
                    $('#mapping-settings-org-units-table').bootstrapTable('refresh');
                })
                .fail((x) => {
                    const errorText = JSON.parse(x.responseJSON).error.message
                        ? JSON.parse(x.responseJSON).error.message
                        : JSON.parse(x.responseJSON).error_description;
                    VjsUtility.Notification.error({
                        text: errorText,
                        time: 5000,
                    });
                })
                .always(() => {});
        },
        clickSaveMappingSettings: (e) => {
            e.preventDefault();
            const selections = $('#mapping-settings-org-units-table').bootstrapTable('getSelections');
            const includes = selections.map((selection) => selection.id);
            const req = new VjsUtility.Request();
            req.post(
                Slim.Router.pathFor('platforms.districts.google.mapping_settings.include.update', {
                    platform_id: platformId,
                    district_joint_guid: districtGuid,
                }),
                { includes },
            )
                .done(() => {
                    successAlert('Org units saved successfully!');
                })
                .fail((x) => {
                    dangerAlert(x.responseJSON.data);
                })
                .always(() => {});
        },
    });

    const initOrgUnitTable = () => {
        $('#mapping-settings-org-units-table').bootstrapTable({
            ...VjsTable.simpleTableDefaults(),
            table: '#mapping-settings-org-units-table',
            formatNoMatches() {
                return 'No organization units available. Try clicking the "Refresh Org Units for District" button.';
            },
            rowStyle() {
                return {
                    css: {
                        width: '50%',
                    },
                };
            },
            method: 'get',
            idField: 'id',
            uniqueId: 'district_joint_guid',
            sortName: 'name',
            search: true,
            pagination: true,
            showColumns: true,
            pageList: [50, 100, 250, 500, 1000, 2000, 2500],
            pageSize: 100,
            sidePagination: 'client',
            clickToSelect: true,
            maintainMetaData: true,
            paginationLoop: false,
            url: Slim.Router.pathFor('platforms.districts.google.mapping_settings.orgunits', {
                platform_id: platformId,
                district_joint_guid: districtGuid,
            }),
            columns: [
                {
                    title: 'district_joint_guid',
                    field: 'district_joint_guid',
                    visible: false,
                },
                {
                    title: 'id',
                    field: 'id',
                    visible: false,
                },
                {
                    title: 'Include',
                    field: 'included',
                    checkbox: true,
                    sortable: false,
                },
                {
                    title: 'Name',
                    field: 'name',
                    align: 'left',
                    class: 'display-name',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Org Path',
                    field: 'orgUnitPath',
                    align: 'left',
                    class: 'display-name',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            responseHandler: (res) => {
                // We need to go ahead and format the included field to true or false now, if we do this in the formatColumn method the pagination wont work correctly
                res.forEach((item, index) => {
                    res[index].included = +res[index].included === 1;
                });

                return {
                    total: res.length,
                    rows: res || [],
                };
            },
        });
    };

    return {
        init,
    };
}());
